import {Axios} from "axios";

export interface PaymentInformationDto {
    id?: number;
    submissionId?: number;
    accountNumber?: string;
    accountNumberComment?: string;
    variableSymbol?: number;
    variableSymbolComment?: string;
    specificSymbol?: string;
    specificSymbolComment?: string;
    amount?: number;
    amountComment?: string;
    currency?: string;
    messageForRecipient?: string;
    messageForRecipientComment?: string;

    paymentText: PaymentTextDto;

    format?: PaymentInformationFormat
}

export enum PaymentInformationFormat {
    ONLY_TEXTS = "ONLY_TEXTS",
    ONLY_PAYMENT_DETAILS = "ONLY_PAYMENT_DETAILS",
    TEXTS_AND_PAYMENT_DETAILS = "TEXTS_AND_PAYMENT_DETAILS"
}

export interface PaymentTextDto {
    prologue?: string;
    mainText?: string;
    epilogue?: string;
}


export class PaymentInformationApiClient {

    constructor(private readonly axios: Axios) {
    }

    findBySubmissionId(submissionId: number): Promise<PaymentInformationDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.get<PaymentInformationDto | undefined>(`/submissions/${submissionId}/payment-information`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                    }
                    reject(error);
                });
        });
    }

    downloadPaymentInformationPdf(submissionId: number): Promise<Blob> {
        return this.axios.get<Blob>(
            `/submissions/${submissionId}/payment-information:generate-pdf`,
            {responseType: "blob"}
        ).then((response) => response.data);
    }
}
